import Variable from '../../../../metadata';
import {DataDefRepo} from '../../../../user-data-defs';
import V1GraphHandler from '../../../graph-handler/v1-graph-handler';

export default abstract class GraphRectifier {
    abstract apply(gh: V1GraphHandler, metadata: Array<Variable>, dataLibrary: Array<Array<Variable>>, datasetRepo: DataDefRepo): void;
}